import * as types from '~/store/mutation-types'
import { SOURCE } from 'enums/source'
import apiV2 from '~/utils/apiV2'

export const state = () => ({
  newNotificationCount: 0,
  isInitialNotificationCountCompleted: {
    [SOURCE.FL]: false
  }
})

export const getters = {
  newNotificationCount: ({ newNotificationCount }) => newNotificationCount,
  isInitialNotificationCountReceived: ({
    isInitialNotificationCountCompleted
  }) => isInitialNotificationCountCompleted[SOURCE.FL]
}

export const actions = {
  async requestBellIconItems() {
    try {
      const { data } = await this.$axiosV2.get(apiV2.me.getBellIconItems())
      return data
    } catch (e) {
      throw e
    }
  },
  async requestMarkReadBellIcon() {
    try {
      await this.$axiosV2.patch(apiV2.me.markReadBellIcon())
    } catch (e) {
      throw e
    }
  },
  async requestDeleteBellIconItem(_, { payload }) {
    try {
      await this.$axiosV2.delete(apiV2.me.deleteBellIconItem(), {
        data: payload
      })
    } catch (e) {
      throw e
    }
  },
  async requestClearAllBellIcon() {
    try {
      await this.$axiosV2.delete(apiV2.me.clearAllBellIcon())
    } catch (e) {
      throw e
    }
  },
  requestSetNewNotificationCount({ commit }, payload) {
    commit(types.SET_NEW_NOTIFICATION_COUNT, payload)
  },
  startInitialNotificationCountRequest({ commit }, { args }) {
    const { source } = args
    commit(types.SET_IS_INITIAL_NOTIFICATION_COUNT_REQUEST_COMPLETED, {
      source,
      value: false
    })
  },
  completeInitialNotificationCountRequest({ commit }, { args }) {
    const { source } = args
    commit(types.SET_IS_INITIAL_NOTIFICATION_COUNT_REQUEST_COMPLETED, {
      source,
      value: true
    })
  }
}

export const mutations = {
  [types.SET_NEW_NOTIFICATION_COUNT](state, count) {
    state.newNotificationCount = count
  },
  [types.SET_IS_INITIAL_NOTIFICATION_COUNT_REQUEST_COMPLETED](
    state,
    { source, value }
  ) {
    state.isInitialNotificationCountCompleted[source] = value
  }
}
